import { Navigate, Outlet } from "react-router-dom";
import { NavigateProps, OutletProps } from "./type";

function PageNavigate(props: NavigateProps) {
  return <Navigate {...props} />;
}
function PageOutLet(props: OutletProps) {
  return <Outlet {...props} />;
}
export { PageNavigate, PageOutLet };
